import React from "react";
import OneSectionDefault from "../oneSection/oneSectionDefault";
// Import Birthday Home Page Images
import birthdayHomeImg1 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__35mm-film-photography-cute-kids-birthday-party-dec__56957.webp';
import birthdayHomeImg2 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__35mm-film-photography-highdetail-living-room-birth__56959.webp';
import birthdayHomeImg3 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__35mm-film-photography-luxury-birthday-balloon-arch__56958.webp';
import birthdayHomeImg4 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__35mm-film-photography-outdoor-birthday-celebration__56960.webp';
import birthdayHomeImg5 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56955.webp';
import birthdayHomeImg6 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56956.webp';
import birthdayHomeImg7 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56961.webp';
import birthdayHomeImg8 from '../../assets/images/BirthdayImages/BirthdayHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56962.webp';

// Birthday Home Page Data Packages
const BirthdayHomePageDataPackages = [
    {
      id: 1,
      title: "Birthday Decoration",
      image: birthdayHomeImg1,
      rating: 4.9,
      reviews: 165,
      currentPrice: 1999,
      originalPrice: 2199,
      discount: 9,
      description: "Beautiful birthday decoration with balloons and lights",
      subImage: [
        {
          imageOne: birthdayHomeImg2,
          imageTwo: birthdayHomeImg3,
          imageThree: birthdayHomeImg4,
          imageFour: birthdayHomeImg5,
        }
      ],
    },
    {
      id: 2,
      title: "Kids Birthday Party",
      image: birthdayHomeImg2,
      rating: 4.8,
      reviews: 185,
      currentPrice: 2099,
      originalPrice: 2499,
      discount: 16,
      description: "Fun and colorful birthday decoration for kids",
      subImage: [
        {
          imageOne: birthdayHomeImg1,
          imageTwo: birthdayHomeImg3,
          imageThree: birthdayHomeImg4,
          imageFour: birthdayHomeImg6,
        }
      ]
    },
    {
      id: 3,
      title: "Luxury Balloon Arch",
      image: birthdayHomeImg3,
      rating: 4.6,
      reviews: 255,
      currentPrice: 2499,
      originalPrice: 2999,
      discount: 17,
      description: "Elegant balloon arch with string lights for birthday celebration",
      subImage: [
        {
          imageOne: birthdayHomeImg1,
          imageTwo: birthdayHomeImg2,
          imageThree: birthdayHomeImg4,
          imageFour: birthdayHomeImg7,
        }
      ]
    },
    {
      id: 4,
      title: "Outdoor Birthday Setup",
      image: birthdayHomeImg4,
      rating: 4.8,
      reviews: 185,
      currentPrice: 2299,
      originalPrice: 2599,
      discount: 12,
      description: "Beautiful outdoor birthday celebration decoration",
      subImage: [
        {
          imageOne: birthdayHomeImg1,
          imageTwo: birthdayHomeImg2,
          imageThree: birthdayHomeImg3,
          imageFour: birthdayHomeImg8,
        }
      ]
    },
    {
      id: 5,
      title: "Living Room Birthday",
      image: birthdayHomeImg2,
      rating: 4.7,
      reviews: 145,
      currentPrice: 2199,
      originalPrice: 2499,
      discount: 12,
      description: "High-detail living room birthday decoration setup",
      subImage: [
        {
          imageOne: birthdayHomeImg1,
          imageTwo: birthdayHomeImg3,
          imageThree: birthdayHomeImg5,
          imageFour: birthdayHomeImg6,
        }
      ]
    },
    {
      id: 6,
      title: "Themed Birthday Party",
      image: birthdayHomeImg5,
      rating: 4.9,
      reviews: 195,
      currentPrice: 2399,
      originalPrice: 2799,
      discount: 14,
      description: "Special themed birthday party decoration",
      subImage: [
        {
          imageOne: birthdayHomeImg2,
          imageTwo: birthdayHomeImg4,
          imageThree: birthdayHomeImg6,
          imageFour: birthdayHomeImg7,
        }
      ]
    },
    {
      id: 7,
      title: "Premium Birthday Setup",
      image: birthdayHomeImg6,
      rating: 4.8,
      reviews: 175,
      currentPrice: 2599,
      originalPrice: 2999,
      discount: 13,
      description: "Premium birthday decoration with luxury balloons",
      subImage: [
        {
          imageOne: birthdayHomeImg1,
          imageTwo: birthdayHomeImg3,
          imageThree: birthdayHomeImg5,
          imageFour: birthdayHomeImg8,
        }
      ]
    },
    {
      id: 8,
      title: "Birthday Celebration",
      image: birthdayHomeImg7,
      rating: 4.7,
      reviews: 155,
      currentPrice: 2199,
      originalPrice: 2499,
      discount: 12,
      description: "Complete birthday celebration decoration",
      subImage: [
        {
          imageOne: birthdayHomeImg2,
          imageTwo: birthdayHomeImg4,
          imageThree: birthdayHomeImg6,
          imageFour: birthdayHomeImg8,
        }
      ]
    }
];

export default function BirthdayHomeSection ({ onNavigate }) {
    return (
        <OneSectionDefault DataPackages={BirthdayHomePageDataPackages} sectionTitle="Birthday Decoration" onNavigate={onNavigate} />
    )
}

export { BirthdayHomePageDataPackages };